import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d384a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
	name: { type: String, required: true }, // svg 图标名称
	className: { type: String, default: '' }, // 指定的类样式
	size: { type: String, default: '32' }, // 图标尺寸
	color: { type: String, default: '#000' }, // 图标颜色
},
  setup(__props) {

const props = __props

const svgClass = computed(() => {
	if (props.className) {
		return 'svg-icon ' + props.className
	} else {
		return 'svg-icon'
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(svgClass.value),
    style: _normalizeStyle({ width: __props.size + 'px', height: __props.size + 'px', color: __props.color }),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", {
      "xlink:href": `#icon-${__props.name}`
    }, null, 8, _hoisted_1)
  ], 6))
}
}

})